import { render } from "./Commencer.vue?vue&type=template&id=0d19d4b9"
import script from "./Commencer.vue?vue&type=script&setup=true&lang=js"
export * from "./Commencer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/private/questionnaire/Commencer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d19d4b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d19d4b9', __exports__)) {
    api.reload('0d19d4b9', __exports__)
  }
  
  module.hot.accept("./Commencer.vue?vue&type=template&id=0d19d4b9", () => {
    api.rerender('0d19d4b9', render)
  })

}


export default __exports__